import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LabelService, AssetService } from '../services';
import { AssetModel } from '../asset';
import { LabelInterface, LabelClass } from '../label';
import { instanceToInstance } from 'class-transformer';

@Component({
  selector: 'app-asset-details-dialog',
  templateUrl: './asset-details-dialog.component.html',
  styleUrls: ['./asset-details-dialog.component.scss']
})
export class AssetDetailsDialogComponent implements OnInit {

  public label: LabelInterface = new LabelClass();

  unchangedData: AssetModel;

  inProgress: boolean = false;

  constructor(public dialogRef: MatDialogRef<AssetDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: AssetModel,
              private assetService: AssetService,
              private labelService: LabelService) {
      this.labelService.assetToLabel(data).subscribe(
        (label) => { this.label = label; }
      );

      this.unchangedData = instanceToInstance(data);
    }

  abort(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.hasDataChanged()) {
      this.inProgress = true;
      this.assetService.update(this.data).subscribe(
        (res) => {},
        (err) => {},
        () => {
          this.inProgress = false;
          this.dialogRef.close(this.data);
        }
      );
    } else {
      this.dialogRef.close(this.data);
    }
  }

  ngOnInit(): void {
  }

  hasDataChanged(): boolean {
    return (JSON.stringify(this.unchangedData) !== JSON.stringify(this.data));
  }

  updateAsset(asset: AssetModel) {
    this.labelService.assetToLabel(this.data).subscribe(
      (label) => { this.label = label; }
    );
  }

}
